import { ModalPopup, SofturaTable } from "client/CommonComponents";
import "./VendorEmailHistory.scss";

const VendorEmailHistory = (props: any) => {
  const {
    fetchAction,
    data,
    columns,
    fleetVendorEmailHistoryMessage,
    showMessage,
    hidePopup,
    serverTotal,
    pagesCount,
  } = props;
  return (
    <>
      <div
        className={"ChangeLog changelog-bulkfleetorder"}
      >
        <div className="softura-table pe-0">
          {
            <div
              className={
                data?.length != 0
                  ? "softura-table pb-3 pe-0"
                  : "softura-table paginationNav"
              }
            >
              <SofturaTable
                data={data ?? []}
                columns={columns}
                sort={false}
                defaultPageSize={10}
                pageSizes={[10, 20, 50]}
                globalSearch={false}
                fetchAction={fetchAction}
                isServerSide={true}
                serverTotal={serverTotal}
                pagesCount={pagesCount}
                defaultPaginationPosition="Both"
                fixedHeader={true}
               data-attribute="VendorEmailHistory_Default_Grid" />
            </div>
          }
        </div>
      </div>
      {showMessage ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle={"Email Message"}
          ModalPopupName={"POVendorEmailMessagePopup"}
          ModalPopupType="medium"
          FooterPrimaryBtnTxt="Close"
          closeModalPopup={hidePopup}
          PrimaryBtnOnclick={hidePopup}
         data-attribute="VendorEmailHistory_Default_ModalPopup">
          <>
          <div className="email-messageLabel">Email Subject</div>
          <div className="email-message"
            dangerouslySetInnerHTML={{
              __html: fleetVendorEmailHistoryMessage?.subject,
            }}
          ></div>
           <div className="email-messageLabel">Email Message</div>
          <div className="email-message"
            dangerouslySetInnerHTML={{
              __html: fleetVendorEmailHistoryMessage?.body,
            }}
          ></div>
          </>
        </ModalPopup>
      ) : null}
    </>
  );
};
export default VendorEmailHistory;
